
import React from 'react';
import api from '../utils/api';
import FormField from './common/FormField';
import { useForm } from './common/useForm';

const ForgotUsernameModal = ({ onClose }) => {

  const [form, handleChange] = useForm({ email: '' });
  const [error, setError] = React.useState('');
  const [message, setMessage] = React.useState('');


  const submit = async () => {
    setError('');
    setMessage('');
    try {
      const response = await api.post('/auth/forgot-username', { email: form.email });
      setMessage(response.data.message || 'Нэвтрэх нэр и-мэйл рүү илгээгдлээ');
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Алдаа гарлаа');
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(event) => event.stopPropagation()}>
        <h3>Нэвтрэх нэр мартсан</h3>
        <div className="form">
          <FormField
            type="input"
            label="И-мэйл"
            name="email"
            typeInput="email"
            placeholder="Бүртгэлтэй и-мэйл"
            value={form.email}
            onChange={handleChange}
            required
          />
          <button onClick={submit}>Илгээх</button>
          {error && <p className="error">{error}</p>}
          {message && <p className="success">{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default ForgotUsernameModal;
